/**
 * Creates a batch request data.
 * @param {number} requestLength
 * @param {Object} requestBody
 * @returns  JSON string
 */
export const createRequestData = (requestLength, requestBody) => {
  const newArray = [];
  let pageNo = 1;
  let requestID = 1;
  for (let index = 0; index < requestLength; index++) {
    newArray.push({
      ...requestBody,
      requestID,
      pageNo,
    });
    pageNo++;
    requestID++;
  }

  const jsonFile = JSON.stringify(newArray);

  return jsonFile;
};

/**
 * Composes batch request response data.
 * @param {Array} reponseData
 * @returns  Array of composed data
 */
export const getResponseData = (reponseData, type) => {
  const newArry = [];

  if (type && type === "CASH_IN_OUT") {
    reponseData.forEach((ele) => {
      if (ele.records.length) {
        ele.records.forEach((rec) => {
          if (rec.sum !== "0.00") {
            newArry.push({ ...rec });
          }
        });
      }
    });
  } else {
    reponseData.forEach((ele) => {
      if (ele.records.length) {
        ele.records.forEach((rec) => {
          newArry.push({ ...rec });
        });
      }
    });
  }

  return newArry;
};

/**
 * Creates a batch request data in chunk.
 * @param {number} requestLength
 * @param {Object} requestBody
 * @returns  chunk array
 */
export const createRequestDataInChunk = (requestLength, requestBody) => {
  const { requestName, recordsOnPage, stocktakingID, sendContentType } =
    requestBody;
  const newArray = [];
  let pageNo = 1;
  let requestID = 1;
  for (let index = 0; index < requestLength; index++) {
    newArray.push({
      requestName,
      recordsOnPage,
      pageNo,
      sendContentType,
      requestID,
      stocktakingID,
    });
    pageNo++;
    requestID++;
  }
  const chunked = chunkArray(newArray, 100);

  return chunked;
};

/**
 * Creates array chunk.
 * @param {Array} array
 * @param {number} len
 * @returns  chunk array of array
 */
export const chunkArray = (array, len) => {
  const chunkedArr = [];
  let i = 0;
  while (i < array.length) {
    chunkedArr.push(array.slice(i, i + len));
    i += len;
  }

  return chunkedArr;
};

/**
 * Get user locale
 * @returns  locale
 */
export const getNavigatorLanguage = () => {
  let locale = Intl.NumberFormat().resolvedOptions().locale;

  if (locale) {
    if (locale.includes("et")) {
      locale = "et-EE";
    }
    return locale;
  } else if (navigator.languages && navigator.languages.length) {
    return navigator.languages[0];
  } else {
    return (
      navigator.userLanguage ||
      navigator.language ||
      navigator.browserLanguage ||
      "en-US"
    );
  }
};

export const composeTransferOrderRequest = (reports) => {
  let newData = [];

  reports.forEach((report, index) => {
    const distnation = report.toWarehouses;
    distnation.forEach((dis) => {
      if (dis.toBeTransferred) {
        const newFile = [...newData];
        const isAdded = newFile.find(
          (e) => e.warehouseToID === dis.warehouseId
        );
        const indexItem = newFile.findIndex(
          (e) => e.warehouseToID === dis.warehouseId
        );
        if (isAdded && indexItem !== -1) {
          isAdded[`productID${index + 1}`] = report.productId;
          isAdded[`amount${index + 1}`] = dis.toBeTransferred;
          newFile[indexItem] = isAdded;
          newData = newFile;
        } else {
          newData.push({
            warehouseFromID: report.fromWarehouse.warehouseId,
            warehouseToID: dis.warehouseId,
            status: "CREATED",
            confirmed: 0,
            [`productID${index + 1}`]: report.productId,
            [`amount${index + 1}`]: dis.toBeTransferred,
            type: "TRANSFER_ORDER",
          });
        }
      }
    });
  });

  return newData;
};

export const formatProductResponse = (res) => {
  let newArry = [];

  if (res.length) {
    res.forEach((product) => {
      let formatted = `${product.code} - ${product.name}`;
      const newData = {
        ...product,
        formatted,
      };
      newArry.push(newData);
    });
  }

  return newArry;
};

export const findRegionWarehousesAndMerge = (
  storeRegionWarehouses,
  locations,
  sourceLocation
) => {
  // const items = [];

  // for (let index = 0; index < warehouses.length; index++) {
  //   if (warehouses[index].storeRegionID === region) {
  //     items.push(warehouses[index].warehouseID);
  //   }
  //   console.log("region", region);
  //   console.log("storeRegionID", warehouses[index].storeRegionID);
  // }

  if (storeRegionWarehouses.length) {
    const newLocations = [...storeRegionWarehouses.map((e) => e.warehouseID)];
    const dist = {};
    for (let i in newLocations) {
      dist[newLocations[i]] = newLocations[i];
    }

    for (let j in locations) {
      if (dist[locations[j]] === undefined) {
        newLocations.push(locations[j]);
      }
    }

    if (newLocations.length) {
      // let newData = [...locations, ...newLocations];

      if (newLocations.includes(sourceLocation)) {
        return newLocations.filter((e) => e !== sourceLocation).toString();
      } else {
        return newLocations.map((e) => e).toString();
      }
    } else {
      if (locations.includes(sourceLocation)) {
        return locations.filter((e) => e !== sourceLocation).toString();
      } else {
        return locations.map((e) => e).toString();
      }
    }
  } else {
    if (locations.includes(sourceLocation)) {
      return locations.filter((e) => e !== sourceLocation).toString();
    } else {
      return locations.map((e) => e).toString();
    }
  }
};

export const formatCurrencyData = (data) => {
  if (data.length) {
    return data.map((e) => ({ ...e, formattedName: `${e.name} (${e.code})` }));
  } else {
    return [];
  }
};

export const getDefaultLang = (defaultLang, languages) => {
  let langCode = "name.en";

  if (languages) {
    languages.forEach((lang) => {
      const { isoCode, legacyIdentifier } = lang;
      if (defaultLang === legacyIdentifier) {
        langCode = `name.${isoCode}`;
        return;
      }
    });
  }

  return langCode;
};
